export default [
  {
    name: "urbainModel",
    type: "gltfModel",
    path: "models/maquette_urbain.glb",
    zone: "urbain",
  },
  {
    name: "periModel",
    type: "gltfModel",
    path: "models/peri_urbain_final.glb",
    zone: "peri",
  },
  {
    name: "vehiculeUrbain",
    type: "gltfModel",
    path: "models/vehicule_urbain_animate.glb",
    zone: "urbain",
  },
  {
    name: "fluxUrbain",
    type: "gltfModel",
    path: "models/flux_urbain.glb",
    zone: "common",
  },
  {
    name: "fluxRural",
    type: "gltfModel",
    path: "models/flux_maquette_rurale.glb",
    zone: "rural",
  },
  {
    name: "vehiculeRural",
    type: "gltfModel",
    path: "models/vehicules_maquette_rurale.glb",
    zone: "rural",
  },
  {
    name: "eoliennes",
    type: "gltfModel",
    path: "models/helice_maquette_rurale.glb",
    zone: "rural",
  },
  {
    name: "ruralModel",
    type: "gltfModel",
    path: "models/maquette_rurale.glb",
    zone: "rural",
  },
  {
    name: "hdriMap",
    type: "hdrFile",
    path: "map/alps_field_1k.hdr",
    zone: "common",
  },
  {
    name: "vehiculeModel",
    type: "gltfModel",
    path: "models/vehicules_peri_urbain.glb",
    zone: "peri",
  },
  {
    name: "flecheModel",
    type: "gltfModel",
    path: "models/flux_maquette1.glb",
    zone: "peri",
  },
  {
    name: "indicator",
    type: "gltfModel",
    path: "models/indicator.glb",
    zone: "common",
  },
  {
    name: "vehiculeModelPeri",
    type: "gltfModel",
    path: "models/vehicule_urbain_animate.glb",
    zone: "peri",
  },
];